/**
 * A server time as the operator reads it: always India time, whatever the
 * browser's zone (owner 2026-10-22: "all time should be IST and should match
 * it is actual"). radaccess v1.132+ sends every time as a real instant
 * (database-clock columns carry +05:30, UTC_TIMESTAMP ones Z), so the instant
 * is formatted in Asia/Kolkata and never shifted again.
 */
const IST = new Intl.DateTimeFormat("en-IN", { dateStyle: "medium", timeStyle: "short", timeZone: "Asia/Kolkata" });

export function istTime(iso?: string | null): string {
  if (!iso) return "—";
  const t = Date.parse(iso);
  return Number.isNaN(t) ? iso : IST.format(t);
}
